import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import recordEmptyImage from "@/assets/agent/record-empty.webp";

export const RecordEmptyImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[recordEmptyImage]}
      {...props}
    />
  );
};

RecordEmptyImage.displayName = 'RecordEmptyImage';
